import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus, Sparkles } from 'lucide-react';
import { StewieCreditsButton } from '@/components/credits/StewieCreditsButton';

interface EmptyStrategyStateProps {
  onAddStrategy: () => void;
}

export const EmptyStrategyState: React.FC<EmptyStrategyStateProps> = ({ onAddStrategy }) => {
  return (
    <div className="flex flex-col justify-center p-6 h-[260px] text-center border border-dashed border-gray-200 rounded-lg bg-gray-50">
      <div className="flex-1"></div>
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-blue-50">
        <Sparkles className="h-6 w-6 text-blue-500" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-1">Create Your First Strategy</h3>
      <p className="text-sm text-gray-500 mb-4 max-w-xs mx-auto">Define your trading approach with custom parameters</p>
      <Button
        onClick={onAddStrategy}
        className="mx-auto w-auto bg-[#221F26] hover:bg-[#403E43] text-white transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 rounded-[4px] mb-4"
      >
        <Plus className="w-4 h-4 mr-2" />
        Add Strategy
      </Button>
      
      {/* Enhanced Credits Section for Empty State - Properly Centered */}
      <div className="flex justify-center items-center w-full">
        <div className="flex justify-center">
          <StewieCreditsButton variant="compact" />
        </div>
      </div>
      
      <div className="flex-1"></div>
    </div>
  );
};
